'use client';

import { useToast } from '../../hooks/use-toast';
import { ToastProvider } from './toast';

export function Toaster() {
  const { toasts, dismiss } = useToast();

  return <ToastProvider toasts={toasts} onClose={dismiss}></ToastProvider>;
}
